module.exports = __webpack_public_path__ + "static/media/whatsapp.c9483442.svg";